import { toast } from "react-toastify";
export const notifySuccess = (message) => toast.success(message);
export const notifyWarn = (message) => toast.warn(message);
